import React, { memo } from 'react'
import VehicleSelectorOption from './VehicleSelectorOption'

const VehicleSelectorOptions = ({
  isDesktop,
  selectBoxData,
  dropHeight,
  overlay,
  resetDefault,
  onChangeHandler,
  onKeyUp,
  selectBoxWidth,
  selectBoxMinWidth,
}) => (
  <>
    {selectBoxData.map(element => (
      <VehicleSelectorOption
        isDesktop={isDesktop}
        key={element.key}
        element={element}
        dropHeight={dropHeight}
        overlay={overlay}
        resetDefault={resetDefault}
        onChangeHandler={onChangeHandler}
        onKeyUp={onKeyUp}
        selectBoxWidth={selectBoxWidth}
        selectBoxMinWidth={selectBoxMinWidth}
      />
    ))}
  </>
)

export default memo(VehicleSelectorOptions)
